"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectedChannelsSelectModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_2 = require("@nextui-org/react");
var get_channels_1 = require("../../../../../../../../api/calls/shopify/get_channels");
var main_1 = require("../../../../../../../../reducers/slices/main");
var get_product_configurations_thunk_1 = require("../../../../../../../../reducers/slices/products/product_configuration/thunks/get_product_configurations_thunk");
var ConnectedChannelsSelectModal = function (_a) {
    var connectedChannels = _a.connectedChannels, onConfirm = _a.onConfirm;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, react_1.useState)(), loading = _b[0], setLoading = _b[1];
    var _c = (0, react_1.useState)([]), selectedChannels = _c[0], setSelectedChannels = _c[1];
    var _d = (0, react_1.useState)([]), activeChannels = _d[0], setActiveChannels = _d[1];
    var getProductConfigurations = function (_a) { return __awaiter(void 0, void 0, void 0, function () {
        var sort_by = _a.sort_by, order_by = _a.order_by, query = __rest(_a, ["sort_by", "order_by"]);
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, dispatch((0, get_product_configurations_thunk_1.get_product_configurations_thunk)(query))];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    }); };
    var channels = activeChannels.filter(function (channel) { return channel.name !== "All"; });
    var fetchChannels = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, seenTypes_1, activeChannels_1, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, (0, get_channels_1.get_channels)({})];
                case 2:
                    response = _a.sent();
                    if (response.success) {
                        seenTypes_1 = new Set();
                        activeChannels_1 = response.content.channel_list.filter(function (_a) {
                            var type = _a.type;
                            if (seenTypes_1.has(type.toLowerCase()))
                                return false;
                            seenTypes_1.add(type.toLowerCase());
                            return true;
                        });
                        setActiveChannels(activeChannels_1);
                    }
                    else {
                        throw new response.message();
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    dispatch((0, main_1.setMessageModal)({
                        title: "Something went wrong when retrieving the product completeness.",
                        messages: ["Failed to fetch product completeness."],
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        fetchChannels();
    }, []);
    var filteredChannels = channels.filter(function (channel) { return !connectedChannels.find(function (connectedChannel) { return connectedChannel.channel_id === channel._id; }); });
    var allSelected = connectedChannels.length === (channels === null || channels === void 0 ? void 0 : channels.length) && filteredChannels.length === 0;
    var channelOptions = filteredChannels
        .sort(function (a, b) { return a.type.localeCompare(b.type); })
        .map(function (channel) { return ({
        channel_id: channel._id,
        name: channel.name,
        channel: channel.type.toUpperCase(),
    }); });
    return ((0, jsx_runtime_1.jsxs)(react_2.Card, __assign({ className: "flex flex-col gap-6 justify-between items-center max-w-md p-4" }, { children: [allSelected && (0, jsx_runtime_1.jsx)("p", __assign({ className: "text-default-500 text-center" }, { children: "No more channels available to add to this product." })), loading ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex justify-center w-full" }, { children: (0, jsx_runtime_1.jsx)(react_2.Spinner, { size: "lg" }) }))) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: "w-[250px]" }, { children: (0, jsx_runtime_1.jsx)(react_2.Select, __assign({ label: "Channels", selectionMode: "multiple", placeholder: "Select channels", className: "w-full", selectedKeys: selectedChannels.map(function (ch) { return ch.channel_id; }), onSelectionChange: function (keys) {
                        var selected = Array.from(keys)
                            .map(function (id) { return channelOptions.find(function (ch) { return ch.channel_id === id; }); })
                            .filter(Boolean);
                        setSelectedChannels(selected);
                    } }, { children: channelOptions.map(function (channel) { return ((0, jsx_runtime_1.jsx)(react_2.SelectItem, __assign({ value: channel.channel_id }, { children: channel.name }), channel.channel_id)); }) })) }))), (0, jsx_runtime_1.jsx)("p", __assign({ className: "text-default-500 text-center text-sm" }, { children: "Adding channels to this product will sync this product across the selected channels upon saving this product." })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-6 justify-center items-center" }, { children: [(0, jsx_runtime_1.jsx)(react_2.Button, __assign({ variant: "bordered", color: "primary", className: "w-[150px]", onClick: function () { return dispatch((0, main_1.setContentModal)(null)); } }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)(react_2.Button, __assign({ color: "primary", className: "w-[150px]", onClick: function () {
                            onConfirm(selectedChannels);
                            dispatch((0, main_1.setContentModal)(null));
                        } }, { children: "Confirm" }))] }))] })));
};
exports.ConnectedChannelsSelectModal = ConnectedChannelsSelectModal;
